module.exports = new Promise ((resolve, reject) => {
    const urlParams = new URLSearchParams(window.location.search);
    let remoteUrlWithVersionAS;

    remoteUrlWithVersionAS = "http://localhost:3003/remoteEntry.js";//"https://qa-exlvantage-AS.exlservice.com/remoteEntry.js";
    const script = document.createElement("script");
    let cookies = document.cookie;
    const cookieArray = cookies.split(";").map((s) => s.split("=").map((s) => s.trim())).reduce((m, [k, v]) => (m.set(k, v), m), new Map());
    const env = cookieArray.get("VANTAGE_ENV");
    //console.log("environent ", env);

    switch (env.toLowerCase()) {
        case "local":
            remoteUrlWithVersionAS = "http://localhost:3000/remoteEntry.js";
            break;
        case "dev":
            remoteUrlWithVersionAS =
                "https://az03-hc-app-accs-cmn-dev.az03-hc-ase-ev-cmn-dev.appserviceenvironment.net/remoteEntry.js";
            break;
        case "qa":
            remoteUrlWithVersionAS =
                "https://qa-exlvantage-AS.exlservice.com/remoteEntry.js";
            break;
        case "uat":
            remoteUrlWithVersionAS = "http://localhost:3000/remoteEntry.js";
            break;
        case "lktuat":
            remoteUrlWithVersionAS = "http://localhost:3000/remoteEntry.js";
            break;
        case "idemo":
            remoteUrlWithVersionAS = "http://localhost:3000/remoteEntry.js";
            break;
        case "test":
            remoteUrlWithVersionAS = "https://testvaccs-infolock.lockton.com/remoteentry.js";
            break;
        case "testazure":
        case "cexltest":
            remoteUrlWithVersionAS = "https://vantagetestas.exlservice.com/remoteEntry.js";
            break;
        case "prod":
            remoteUrlWithVersionAS = "https://vaccs-infolock.lockton.com/remoteentry.js";
            break;
        default:
            remoteUrlWithVersionAS = "";
            break;
    }
    script.src = remoteUrlWithVersionAS + "?v=19.4";
    script.onload = () => {
        // the injected script has loaded and is available on window
        // we can now resolve this Promise
        const proxy = {
            get: (request) => window.AS.get(request),
            init: (arg) => {
                try {
                    return window.AS.init(arg);
                } catch (e) {
                    console.log("remote container already initialized");
                }
            },
        };
        resolve(proxy);
    };
    script.onerror = () => {
        reject();
        //alert("Error loading " + this.src); // Error loading https://example.com/404.js
        // document.head.appendChild(null);
        //return null;
    };
    // inject this script with the src set to the versioned remoteEntry.js
    document.head.appendChild(script);
});